!(function () {
  const tabLists = document.querySelector(".c-tabs__tabs");
  const tabs = document.querySelector(".c-tabs__panels");
  if (!tabLists || !tabs) return;
  tabLists.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!event.target) return;
    let txt = event.target.innerHTML.trim();
    let tab = document.querySelector(`[id="${txt}"]`);
    if (!tab) return;
    for (let element of event.currentTarget.children) {
      element.classList.remove("active");
    }
    event.target.closest("li").classList.add("active");
    for (let element of tabs.children) {
      element.classList.remove("selected");
    }
    tab.classList.add("selected");
  });
  tabs.addEventListener("change", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!event.target) return;
    const charts = event.currentTarget.querySelectorAll(".sizecharts_incm");
    charts.forEach((chart) => {
      let elems = chart.children;
      for (let elem of elems) {
        elem.classList.remove("selected");
      }
    });
    if (event.target.value == "centimeters") {
      let cminputs = event.currentTarget.querySelectorAll(
        'input[value="centimeters"]'
      );
      cminputs.forEach((input) => (input.checked = true));
      charts.forEach((chart) =>
        chart.lastElementChild.classList.add("selected")
      );
    } else {
      let cminputs = event.currentTarget.querySelectorAll(
        'input[value="inches"]'
      );
      cminputs.forEach((input) => (input.checked = true));
      charts.forEach((chart) =>
        chart.firstElementChild.classList.add("selected")
      );
    }
  });
})();
